export const generateSeedWithAddress = (address: string) => parseInt(address.slice(2, 10), 16);
